export default __webpack_public_path__ + "static/landing-section-3-img-1-928c2e46187027866d4f0a7c4b228bf7.png";